export default function Laptop(props: any) {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_570_18943)">
                <path
                    d="M3.42773 23.1416V6.60971C3.42773 5.84864 4.02039 5.23145 4.75166 5.23145H27.2484C27.9797 5.23145 28.5724 5.84864 28.5724 6.60971V23.1416"
                    stroke="#757575"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M30.1123 26.7695H1.88764C1.64191 26.7695 1.44287 26.5624 1.44287 26.3066L3.21178 23.2284H28.3902L30.5571 26.3066C30.5571 26.5624 30.358 26.7695 30.1123 26.7695Z"
                    stroke="#757575"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15.3633 6.85254H16.636" stroke="#757575" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_570_18943">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
